<template>
  <div class="app flex-row align-items-center">
    <div v-if="!this.loading" class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card>
            <h1 class="center">Bienvenido</h1>
            <p class="text-muted center">Inicie sesión con su cuenta</p>
            <formDinamic :typeEndPoint="'login'" :formSchema="this.dataLoad.formSchema" :formData="this.dataLoad.formData" :params="{}" />
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import formDinamic from '@/views/base/form/Form.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  components: {
    formDinamic
  },
  computed: {
    ...mapGetters({
      auth: 'auth'
    })
  },
  data () {
    return {
      loading: true,
      dataLoad: {}
    }
  },
  mounted () {
    this.$store.dispatch('Formlogin').then((response) => {
      this.dataLoad = this.auth
      console.log(this.dataLoad.formData)
      this.loading = false
    }).catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue